import { ReactNode } from 'react';
import { IconButton, styled, useTheme } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../assets/icons/close-grey.svg';

import { Typography } from '../Typography/Typography';

type Props = {
  title: string;
  onClose: () => void;
  headerExtra?: ReactNode;
};

export const ModalHeader = ({ title, onClose, headerExtra }: Props) => {
  const { colors } = useTheme();
  return (
    <Container>
      <TitleWrapper>
        <Typography variant='h4' color={colors.text.main} style={{ flexShrink: 0 }}>
          {title}
        </Typography>
        {headerExtra}
      </TitleWrapper>
      <IconButton
        onClick={onClose}
        aria-label='Close'
        size='small'
        sx={{
          ml: 2.5,
          p: 0,
          width: 28,
          height: 28,
          flexShrink: 0,
        }}
      >
        <CloseIcon />
      </IconButton>
    </Container>
  );
};

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.surfaceBackground.bg1};

  position: sticky;
  top: 0;
  z-index: 1;
`;

const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;
